import app from "./app";
import asset from "./asset";
import components from "./components";
import graph from "./graph";
import ontology from "./ontology";
import panel from "./panel";
import skos from "./skos";
import utils from "./utils";
import view from "./view";
import views from "./views";
import io from "./io";
import service from "./service";

export default {
  app,
  asset,
  graph,
  components,
  ontology,
  panel,
  skos,
  utils,
  view,
  views,
  io,
  service
};
